import { atom } from "jotai";

import { defaultFiltersParams } from "#app/routes/pages/Search.page";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { QuoteRequestDto } from "#modules/quoteRequests/infra/fetchQuoteRequest.api";
import { Client, FilterQuery } from "shared";

export type ClientAtom = Pick<Client, "id" | "name"> | null;

export type QuoteRequestAtom =
  | (Omit<QuoteRequestDto, "quoteRequestLines"> & {
      quoteRequestLines: QuoteRequestLineDto[];
    })
  | null
  | undefined;

export const quoteRequestAtom = atom<QuoteRequestAtom>(null);

export const quoteRequestisEditing = atom(false);

export const filtersParamsAtom = atom<FilterQuery>(defaultFiltersParams);
